import React from 'react'
import Button from '@mui/material/Button'
import { useQuery } from '~/client/hooks/cqrpc'
import Link from '~/client/components/Link'
import Heading from '~/client/components/Heading'
import LoadingList from '~/client/components/LoadingList'
import AppIcon from '~/client/components/AppIcon'
import ButtonRow from '~/client/components/ButtonRow'

export default function Page(props) {
  const { result: apps, loading, error } = useQuery('apps.getMine')

  return <LoadingList {...{
    loading,
    onEmpty: <>
      <Heading variant="sub">No OAuth applications</Heading>
      <p>
        OAuth applications are used to access the DataPal API. <Link>Read the docs</Link> to find out more.
      </p>
      <Button
        variant="contained"
        color="success"
        component={Link}
        to="/settings/apps/new"
      >Register a new application</Button>
    </>,
    header: (
      <ButtonRow><NewAppButton/></ButtonRow>
    ),
    members: apps && apps.map(app => ({
      key: app.id,
      href: `/settings/apps/${app.host}`,
      icon: <AppIcon app={app}/>,
      text: app.name,
      subtext: app.host,
    }))
  }}/>
}

function NewAppButton(){
  return <Button {...{
    variant: 'outlined',
    color: 'primary',
    component: Link,
    to: '/settings/apps/new',
  }}>New App</Button>
}
